import React from 'react'
import { Route, Switch } from 'react-router-dom'
import { Organization } from './page/organization'
import { OrganizationDelete } from './page/organization-delete'
import { ScheduledLanding } from './page/organization-scheduled'
import { SCHEDULED_PATH } from '../../../../shared/organization-deletion/organization-deletion'
import { useRoleOrgOrganization } from '../../../../role/hook/role-org'
import { useRoleContext } from '../../../../role/role.context'
import { NoAccess } from '../../../../role/components/no-access'
import { PageTrail } from '../../../../shared/sso-workspace/page-trail'
import { SECTION } from '../../../../shared/navigation/sections'

// /org/organization: the organization's own page and its danger zone
// (delete organization, plan Task 26). The restore page is the restricted
// session's (restricted-shell.js); in an ordinary session its path only
// lands (ScheduledLanding).
//
// Without the organization's read (staff in an organization of their own,
// say) the page says so under the sidebar's crumb, once the roles have
// loaded, instead of drawing nothing at all (audit F23).
export const LayoutOrganization = () => {
  const role = useRoleOrgOrganization()
  const roleContext = useRoleContext()
  const known = !!(roleContext && roleContext.orgLoaded)

  return (
    <Switch>
      {role.accessRead && <Route exact path="/org/organization" component={Organization} />}
      {role.accessRead && <Route exact path="/org/organization/delete" component={OrganizationDelete} />}
      <Route exact path={SCHEDULED_PATH} component={ScheduledLanding} />
      {!role.accessRead && known &&
        <Route exact path={['/org/organization', '/org/organization/delete']}>
          <PageTrail trail={[SECTION.organization]} />
          <NoAccess what="this organization's settings" />
        </Route>}
    </Switch>
  )
}
